import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=a510539c&scoped=true&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"
import style0 from "./Resources.vue?vue&type=style&index=0&id=a510539c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a510539c",
  null
  
)

export default component.exports